export function getFarsiInfinitive(pastStem: string, primaryVerb: string = ""): string {
  let result = pastStem ? `${pastStem}\u064e\u0646` : '';
  if (primaryVerb) {
    result = primaryVerb + " " + result;
  }
  return result;
}